export default "__VITE_ASSET__CBpYgZlK__"